import { Module } from 'vuex';
import { LoginTypeState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: LoginTypeState = {
    list: undefined,
    index: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
};

const namespaced: boolean = true;

export const loginType: Module<LoginTypeState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
